var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: _vm.dialogWidth,
        "close-on-click-modal": false,
        "show-close": false,
        "before-close": _vm.handleBeforeClose,
        modal: false,
        "modal-append-to-body": false,
        "append-to-body": true,
        "custom-class": "video-call-dialog vertical-mode",
        top: "10vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
      nativeOn: {
        mousedown: function ($event) {
          return _vm.startDrag.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
              return _vm.startDrag.apply(null, arguments)
            },
          },
          slot: "title",
        },
        [
          _c("span", [
            _vm._v("视频问诊 — " + _vm._s(_vm.patientInfo.name || "-")),
          ]),
          _c("el-tag", { attrs: { size: "mini", type: _vm.callStatusType } }, [
            _vm._v(_vm._s(_vm.callStatusText)),
          ]),
          _c("i", {
            staticClass: "el-icon-rank drag-handle",
            attrs: { title: "拖动" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "video-wrap vertical" }, [
        _c(
          "div",
          {
            staticClass: "video-box remote-box",
            attrs: { id: "trtc-remote-video" },
          },
          [
            !_vm.remoteReady
              ? _c("div", { staticClass: "video-placeholder" }, [
                  _c("i", { staticClass: "el-icon-video-camera" }),
                  _c("span", [_vm._v(_vm._s(_vm.remotePlaceholderText))]),
                ])
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "video-box local-box",
            attrs: { id: "trtc-local-video" },
          },
          [
            !_vm.localReady
              ? _c("div", { staticClass: "video-placeholder small" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                  _c("span", [_vm._v("本地摄像头")]),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", icon: "el-icon-phone" },
              on: { click: _vm.handleHangup },
            },
            [_vm._v("挂断通话")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: _vm.micMuted ? "info" : "primary" },
              on: { click: _vm.toggleMic },
            },
            [_vm._v(" " + _vm._s(_vm.micMuted ? "麦克风已关" : "麦克风") + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: _vm.cameraOff ? "info" : "primary" },
              on: { click: _vm.toggleCamera },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.cameraOff ? "摄像头已关" : "摄像头") + " "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }